import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { PageHero } from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { FAQS } from "@/data/site";

export default function FAQ() {
  return (
    <div data-testid="faq-page">
      <PageHero
        overline="FAQ"
        titleLines={["Questions,", "answered."]}
        subtitle="Everything you need to know about attendance, reminders, subscriptions and security."
      />

      <section className="mx-auto max-w-3xl px-5 pb-24 lg:px-8">
        <Reveal>
          <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
            {FAQS.map((f, i) => (
              <AccordionItem key={i} value={`item-${i}`} className="border-b border-white/10">
                <AccordionTrigger
                  data-testid={`faq-trigger-${i}`}
                  className="py-6 text-left font-heading text-lg font-medium text-white hover:text-brand hover:no-underline"
                >
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="pb-6 text-base leading-relaxed text-zinc-400">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>

        <Reveal className="mt-14 rounded-2xl border border-zinc-800 bg-surface p-8 text-center">
          <h3 className="font-heading text-xl font-semibold text-white">Still have questions?</h3>
          <p className="mt-2 text-sm text-zinc-400">Our team is happy to help you get set up.</p>
          <Link to="/contact" data-testid="faq-contact-btn" className="mt-6 inline-flex items-center gap-2 rounded-md bg-brand px-6 py-3 text-sm font-semibold text-white transition-colors hover:bg-brand-hover">
            Contact Us <ArrowRight className="h-4 w-4" />
          </Link>
        </Reveal>
      </section>
    </div>
  );
}
